globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};

appCustomerSpace.Modals.AddToHomeScreen = (function(superClass) {

  utils.extend(AddToHomeScreen, superClass);

  function AddToHomeScreen() {
    return AddToHomeScreen.__super__.constructor.apply(this, arguments);
  }

  $.extend(AddToHomeScreen.prototype, {
    init: function() {
      this.initEvents();

      var userAgent = navigator.userAgent.toLowerCase();

      if(userAgent.indexOf("android") > -1) {
        this.$html.find('.add-to-home-screen-android-steps').show();
        this.$html.find('.add-to-home-screen-apple-steps').hide();
      } else if(userAgent.indexOf("apple") > -1) {
        this.$html.find('.add-to-home-screen-android-steps').hide();
        this.$html.find('.add-to-home-screen-apple-steps').show();
      }

      return AddToHomeScreen.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      var modal = this;
      modal.$html.on('click', '.declare-pwa-installation-btn', function(){
        var $declarePwaInstallationtBtn = $(this);
        var url = $declarePwaInstallationtBtn.data('url');

        if (url) {
            $.ajax({
                type: "POST",
                url: url,
                success: function(data)
                {
                    if (data.response == 1) {
                        modal.close();
                    } else {
                        modal.close();
                    }
                }
            })
        }
      });
      modal.$html.on('click', '.postpone-pwa-installation-btn', function(){
        var $PostponePwaInstallationBtn = $(this);
        var url = $PostponePwaInstallationBtn.data('url');

        if (url) {
            $.ajax({
                type: "POST",
                url: url,
                success: function(data)
                {
                    if (data.response == 1) {
                        modal.close();
                    } else {
                        modal.close();
                    }
                }
            }).fail(function() {
                alert(errorMsg);
            });
        }
      });
    }
  });

  return AddToHomeScreen;
})(appCustomerSpace.Modal);
